import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { Link, useParams } from 'react-router-dom';

import SurveyListHeader from '../../../component/layout/MainHeader';
import SurveyListSidebar from '../../../component/layout/MainSidebar';

import PuckEditor from './components/PuckEditor';
import Range from './components/Range';

export default function ROITemplates() {
    const { id } = useParams();
    const [roiName, setRoiName] = useState('');

    useEffect(() => {
        const apiUrl = process.env.REACT_APP_NODE_API_URL;
        const fetchRoiName = async () => {
            try {
                const response = await fetch(`${apiUrl}/roi/getRoiDetail/${id}`);
                const data = await response.json();
                setRoiName(data?.data?.roi_name || '');
            } catch (error) {
                setRoiName('');
            }
        };
        if (id) fetchRoiName();
    }, [id]);

    return (
        <>
            <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">
                        <div className="dashboard-page-outer flex-grow-1">
                            <div className="custom-breadcrumb">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/roi" className="home-item" title="Calculator">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <strong>{roiName || ""}</strong>
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <PuckEditor />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
